<span [attr.data-cy]='dataCy'>
  {{message}}
</span>
